var crypto = require('crypto')

function base64To(form) {
  const secretKey = "UWQSMFeqIhnOngrsEjpiwLR6zfyhLTWziLWzf1E4llXEMpagY4iDUSzHikDv2kLC";
  const jsonData = JSON.stringify(form);
  const hmac = crypto.createHmac("sha512", secretKey);
  hmac.update(jsonData);
  const hash = hmac.digest("base64");
  return hash;
}
export {
  base64To
}
